export function manageListConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: true,
    selection: true,
    selectionWidth: 45,
    searchShow: false,
    column: [
      {
        label: "合同名称",
        prop: "contractName",
        width: "160",
        searchPlaceholder: "项目编号/项目名称",
        placeholder: "项目编号/项目名称",
        search: true,
        slot:true
      },
      {
        label: "项目类型",
        prop: "projectType",
        type: "select",
        display: false,
        overHidden: true,
        dataType: "number",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zg_fund_projectType',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
      },
      {
        label: "审批状态",
        prop: "auditStatus",
        type: "select",
        search: true,
        dataType: 'number',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=project_build_state",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        display: false,
        overHidden: true,
        // formatter: (row, value, label, column) => {
        //   return value == 2?'已核销':'未核销'
        // }
      },      
      {
        label: "付款金额",
        prop: 'investMoney',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },
      {
        label: "计划放款日期",
        prop: 'planPayDate',
        width:'120'
      },      

      // {
      //   label: '项目名称',
      //   prop: 'name',
      //   bind: 'dzContractVO.dzReportVO.name',
      //   width: '120'
      // },
      {
        label: "放款状态",
        prop: "isWriteoff",
        search: true,
        type: 'select',
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_writeoff",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
      },
      // {
      //   label: '证券名称',
      //   prop: 'securitiesName',
      //   bind: 'dzContractVO.dzReportVO.dzProjectVO.securitiesName',
      //   width: '120'
      // },
      // {
      //   label: '证券代码',
      //   prop: 'securitiesNo',
      //   bind: 'dzContractVO.dzReportVO.dzProjectVO.securitiesNo',
      //   width: '120'
      // },
      // {
      //   label: '合同金额(元)',
      //   prop: 'contractMoney',
      //   bind: 'dzContractVO.contractMoney',
      //   width: '120',
      //   formatter: (row, value, label, column) => {
      //     return `${getMoney(row.dzContractVO.contractMoney)}`;
      //   }
      // },
      {
        label: "经办人",
        prop: "managerName",
        display: true,
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: "150"
      },
      {
        label: '核销人员',
        prop: 'writeoffUserName'
      },{
        label: '核销时间',
        prop: 'writeoffTime',
        width: '180',
        overHidden: true
      }
    ]
  }
}


export function fundPaymentAddConfig() {
  return {
    labelWidth: 200,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: "合同名称",
        prop: "contractName",
        span: 8,
        overHidden: true,
        display: true,
        disabled: false,
        formslot: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }],
      }, {
        label: '预计付款日期',
        prop: "planPayDate",
        type: 'date',
        valueFormat: 'yyyy-MM-dd',
        span: 8,
        disabled: false,
        rules: [{
          required: true,
          message: "请选择预计起息日",
          trigger: "change"
        }]
      }, {
        label: "付款主体",
        prop: 'payEntityName',
        formslot: true,
        span: 8
      }, {
        label: "开户信息",
        prop: 'bankAccountForm',
        formslot: true,
        display: true,
        span: 8,
      }, {
        label: "开户信息",
        prop: 'bankAccountForm',
        display: false,
        span: 8,
      },{
        label: "付款金额",
        prop: "contractMoneyStr",
        span: 8,
        overHidden: true,
        display: true,
        append: '元',
        disabled: true,
        alwaysDisabled: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        },
        rules: [{
          required: true,
          message: "请输入付款金额",
          trigger: "blur",
        }],
      },{
        label: "大写金额",
        prop: 'moneyChinese',
        disabled: true,
        alwaysDisabled: true,        
        span: 8,
      },{
        label: "收款人帐号",
        prop: 'bankNo',
        span: 8,
        rules: [{
          required: true,
          message: "请输入收款人帐号",
          trigger: "blur",
        }],
      },{
        label: "收款人户名",
        prop: 'bankAccountName',
        span: 8,
        rules: [{
          required: true,
          message: "请输入收款人户名",
          trigger: "blur",
        }],
      },{
        label: "收款人开户行",
        prop: 'bankOpenName',
        span: 8,
        rules: [{
          required: true,
          message: "请输入收款人开户行",
          trigger: "blur",
        }],
      },{
        label: "付款人帐号",
        prop: "payBankNo",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },{
        label: "付款人户名",
        prop: "accountName",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },{
        label: "付款人开户行",
        prop: "openningBank",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },{
        label: "项目类型",
        prop: "projectType",
        type: 'select',
        disabled:true,
        alwaysDisabled: true,
        span: 8,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zg_fund_projectType',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
      },{
        label: "证券名称",
        prop: "securitiesName",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },{
        label: "证券代码",
        prop: "securitiesNo",
        span: 8,
        disabled: true,
        alwaysDisabled: true,
        placeholder: "请选择项目"
      },
    ]
  }
}
